//@ts-check
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, message, Select, Card, Input, Modal, Spin } from 'antd';
import FullLayout from '../../../layout/full-layout/full-layout';
import { FormInput, FormContainer } from '../../../module/form';
import { signIn } from '../../../redux/actions/accountAction';
import logo from '../../../assets/images/logo.png';
import './login.scss';
import { getCurrentAccountState, getLanguageState } from 'redux/selectors';
import { FormattedMessage, injectIntl } from 'react-intl';
import TwoFactorModal from './two-factor-modal';
import { getfetchopts } from 'utils/fetchutils';
import axios from 'axios';
// import { account } from 'api';
const { Option } = Select;
class Login extends PureComponent {
    state = {
        spinning: false,
        visible: false,
        values: {},
        twoFactorVisible: false,
        gatewayId: undefined,
        sessionId: undefined 
    };
    handleSubmit = async (values, isResend) => {
        try {
            if (!isResend) {
                if (values.username) {
                    values.username = values.username.toLocaleLowerCase();
                    values['language'] = this.props.language || 'en-US';
                }
                this.setState({
                    values: values
                })
            }
            else {
                values = this.state.values;
            }
            await this.login(values);

        } catch (e) {
            message.error(e?.response?.data?.message || 'Incorrect username or password');
        }
    };
    login = async (values) => {
        if (values) {
            values['language'] = this.props.language || 'en-US';
        }
        let query;
        try {
            const { location } = window;
            query = new URLSearchParams(location.search);
        } catch (err) {
            console.error('Error getting query params', err);
        }
        let sessionId = this.state.sessionId;
        const gatewayId = query ? query.get('gatewayId') : undefined;
        if (!sessionId) {
            const config = getfetchopts({
                method: "POST",
                url: "/api/identity/auth/mfa",
                data: {
                    username: values.username,
                    password: values.password,
                },
            });
            const response = await axios(config);
            // //@ts-ignore
            console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);
            sessionId = response.data.session_id;
        }

        if (sessionId) {
            this.setState({ twoFactorVisible: true, gatewayId, sessionId: sessionId });
        } else {
            this.handleTwoFactorSubmit();
        }
    };

    handleTwoFactorSubmit = async (code) => {
        try {
            const { values, gatewayId, sessionId: session_id } = this.state;
            let query;
            try {
                query = new URLSearchParams(window.location.search);
            } catch (err) {
                console.error('Error getting query params', err);
            }
            const login = await this.props.signIn({ ...values, code, gatewayId, session_id });
            this.setState({ twoFactorVisible: false, spinning: true });
            if (login && login.isTemporaryPassword) {
                if (login.lastLogin) {
                    setTimeout(
                        () => this.props.history.push('/change-password'),
                        100,
                    );
                } else {
                    setTimeout(
                        () => this.props.history.push('/change-temp-password'),
                        100,
                    );
                }
            } else {
                if (!login) throw new Error('Login failed, unknown error');
                const continueQuery = query ? query.get('continue') : undefined;
                if (continueQuery) {
                    if (!login.authorizationCode) throw new Error('Login failed, unauthorized');
                    const continueTo = `${continueQuery}${continueQuery.includes('?') ? '&' : '?'}authorization_code=${encodeURIComponent(login.authorizationCode)}`;
                    window.location.href = continueTo;
                    return;
                }
                setTimeout(() => this.props.history.push('/accounts'), 100);
            }
        } catch (error) {
            if (this.state.sessionId) {
                this.setState({ spinning: false, twoFactorVisible: true });
                Modal.error({
                    title: 'Verification Failed',
                    content: 'Invalid verification code provided, please try again.',
                });
            } else {
                message.error(error.message);
            }
        }
    };

    handleTwoFactorCancel = () => {
        this.setState({ twoFactorVisible: false });
    };

    handleTwoFactorResend = () => {
        this.setState({ sessionId: undefined }, () => {
            this.handleSubmit(null, true);
        });
        message.success("A new pin code has been sent to your email address");
    };

    async componentDidMount() {}
    render() {
        const { intl, currentUser } = this.props;
        return (
            <FullLayout className="login-layout">
                <TwoFactorModal
                    visible={this.state.twoFactorVisible}
                    onVerify={this.handleTwoFactorSubmit}
                    onCancel={this.handleTwoFactorCancel}
                    onResend={this.handleTwoFactorResend}
                />
                {intl.formatMessage({
                    id: 'login.mylogin',
                    defaultMessage: '',
                }) !== 'loading' && (
                        <div className="login">
                            <div className="login-form">
                                <Spin spinning={this.state.spinning}>
                                    <FormContainer
                                        onSubmit={this.handleSubmit}
                                        loading={true}
                                    >
                                        <div className="text-center">
                                            <img
                                                className="logo"
                                                src={logo}
                                                alt="logo"
                                            />
                                        </div>

                                        <div className="text-center">
                                            <h1 className="title">
                                                <FormattedMessage
                                                    id="login.title"
                                                    defaultMessage="Sign in to AMIE Console"
                                                />
                                            </h1>
                                            <h6 className="txt-grey sub-title">
                                                <FormattedMessage
                                                    id="login.subtitle"
                                                    defaultMessage="Enter your details below"
                                                />
                                            </h6>
                                        </div>
                                        <br />
                                        <FormInput
                                            label={
                                                <FormattedMessage
                                                    id="login.username"
                                                    defaultMessage="Username"
                                                />
                                            }
                                            name="username"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: (
                                                        <FormattedMessage
                                                            id="login.username.required"
                                                            defaultMessage="Please input your username!"
                                                        />
                                                    ),
                                                },
                                            ]}
                                            placeholder={intl.formatMessage({
                                                id: 'login.username',
                                                defaultMessage: 'Username',
                                            })}
                                            maxLength={128}
                                        />
                                        <Link
                                            className="login-form-forgot"
                                            to="/forgot-password"
                                        >
                                            <FormattedMessage
                                                id="login.forgot_password"
                                                defaultMessage="Forgot password ?"
                                            />
                                        </Link>
                                        <FormInput
                                            label={
                                                <FormattedMessage
                                                    id="login.password"
                                                    defaultMessage="Password"
                                                />
                                            }
                                            name="password"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: (
                                                        <FormattedMessage
                                                            id="login.password.required"
                                                            defaultMessage="Please input your Password!"
                                                        />
                                                    ),
                                                },
                                            ]}
                                            type="password"
                                            placeholder={intl.formatMessage({
                                                id: 'login.password',
                                                defaultMessage: 'Password',
                                            })}
                                        />

                                        <div className="options">
                                            {/* <FormCheckbox
                                    name="remember"
                                    checked={true}
                                    label="Keep me logged in"
                                /> */}

                                            {/* <div class="ant-row ant-form-item form-checkbox">
                                        <div class="ant-col ant-form-item-control-wrapper">
                                            <div class="ant-form-item-control has-success"></div>
                                        </div>
                                    </div> */}

                                            <Link
                                                className="login-form-signup"
                                                to="/signup"
                                            >
                                                <FormattedMessage
                                                    id="login.sign_up"
                                                    defaultMessage="Sign-Up"
                                                />
                                            </Link>
                                        </div>
                                        <Button
                                            shape="round"
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            className="login-form-button"
                                        >
                                            <FormattedMessage
                                                id="login.sign_in"
                                                defaultMessage="SIGN IN"
                                            />
                                        </Button>
                                        {/* <p>
            By accessing the AMiE Portal you accept and agree to be bound to the <Link to="/terms-and-conditions">End-User License Agreement Terms and Conditions</Link>
        </p>
        <p>
            © 2020 Spectralink TM | <Link to="/privacy-policy">Privacy Policy</Link>  | <Link to="/terms-and-conditions">Terms of Use</Link>
        </p> */}
                                    </FormContainer>
                                </Spin>
                            </div>
                        </div>
                    )}
            </FullLayout>
        );
    }
}
function mapStateToProps(state) {
    return {
        language: getLanguageState(state) || 'en-US',
        currentAccount: getCurrentAccountState(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        signIn: (params) => dispatch(signIn(params)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Login));
